import { Rss } from "lucide-react";
import { Button, Icon } from "@generalapplications/ui";

/** The feed, opened in a new tab: a feed reader's address, not a page here. */
export function BlogRssLink() {
  return (
    <Button
      href="/feed.xml"
      external
      variant="outline"
      size="sm"
      title="Subscribe via RSS Feed"
    >
      <Icon icon={Rss} placement="start" />
      RSS Feed
    </Button>
  );
}
